import { Model } from "survey-core";
import { APIURL } from "../../../../config/api";

export function getMedicalConditionElements(
  prefix: string,
  isPerson2: boolean
) {
  let yourReplace = isPerson2 ? "their" : "your";
  let youReplace = isPerson2 ? "they" : "you";

  return [
    // General Fields
    {
      type: "dropdown",
      name: "conditionType",
      title: "What type of condition is this?",
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true'`,
      isRequired: true,
      choices: [
        { value: "208", text: "Other" },
        { value: "210", text: "Heart" },
        { value: "211", text: "Diabetes" },
        { value: "212", text: "Cancer" },
        { value: "213", text: "Stroke" },
        { value: "214", text: "Respiratory" },
        { value: "215", text: "Multiple Sclerosis" },
        { value: "216", text: "Neurological" },
        { value: "218", text: "High Blood Pressure" },
        { value: "219", text: "High Cholesterol" },
      ],
    },
    {
      type: "dropdown",
      name: "neurologicalType",
      title: "What type of neurological condition is this?",
      isRequired: true,
      visibleIf: "{panel.conditionType} = '216'",
      choices: [
        { value: "6016", text: "Alzheimer's Disease" },
        { value: "6017", text: "Parkinson's Disease" },
        { value: "6019", text: "Other" },
        { value: "100995", text: "Senile Dementia" },
        { value: "100996", text: "Vascular Dementia" },
        { value: "100997", text: "Motor Neurone Disease" },
      ],
    },
    // {
    //   type: "dropdown",
    //   name: "conditionName",
    //   title: "What is the medical name for this condition?",
    //   visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({panel.conditionType} = '208' || {panel.conditionType} = '212' || {panel.conditionType} = '210' || {panel.conditionType} = '214' || ({panel.conditionType} = '216' && {panel.neurologicalType} = '6019'))`,
    //   choicesByUrl: {
    //     url: `${APIURL}/medical/conditions?conditionCategoryid={panel.conditionType}`,
    //     valueName: "name",
    //   },
    // },
    // https://localhost:7081/api/medical/conditions?labelFilter=&take=25

    {
      type: "dropdown",
      name: "conditionName",
      title: "What is the medical name for this condition?",
      lazyLoad: true,
      choicesLazyLoadEnabled: true,
      choicesLazyLoadPageSize: 10,
      choicesURL: `${APIURL}/medical/conditions`,
      displayValuesURL: `${APIURL}/medical/conditions`,
      takeParameterName: "take",
      choicesFilterParameterName: "labelFilter",
      displayValuesFilterParameterName: "labelFilter",
      categoryParameterName: "conditionCategoryID",
      categoryFieldName: "conditionType",
      placeholder: "Please start typing to search...",
      visibleIf:
        "{panel.conditionType} != '219' && {panel.conditionType} != '218' && {panel.conditionType} != '215' && {panel.conditionType} != '211'",
    },

    {
      type: "text",
      name: "customerProvidedMedicalConditionName",
      title: "Please specify the condition name",
      isRequired: true,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {panel.conditionName} = 'Unknown'`,
      placeholder: "Enter condition name",
    },
    {
      type: "text",
      name: "dateDiagnosed",
      title: "When was this diagnosed?",
      isRequired: true,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({panel.conditionType} = '208' || {panel.conditionType} = '210' || {panel.conditionType} = '211' || {panel.conditionType} = '212' || {panel.conditionType} = '213' || {panel.conditionType} = '214' || {panel.conditionType} = '215' || {panel.conditionType} = '216' || {panel.conditionType} = '218' || {panel.conditionType} = '219')`,
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "text",
      name: "lastSufferedSymptoms",
      title: `When did ${youReplace} last experience symptoms?`,
      isRequired: true,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && {panel.conditionType} = '208'`,
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "text",
      name: "numberOfHospitalAdmissions",
      title: `How many times have ${youReplace} been admitted to hospital due to this condition?`,
      visibleIf: `{${prefix}.lifestyleAndMedicalDeclaration} = 'true' && ({panel.conditionType} = '208' || {panel.conditionType} = '210' || {panel.conditionType} = '211' || {panel.conditionType} = '214' || {panel.conditionType} = '215' || {panel.conditionType} = '216')`,
      inputType: "number",
      min: 0,
      max: 99,
      validators: [
        {
          type: "regex",
          text: "Please enter a valid number between 0 and 99.",
          regex: "^([0-9]|[1-9][0-9])$",
        },
      ],
    },
    {
      type: "text",
      name: "lastHospitalised",
      title: `When were ${youReplace} last admitted to hospital?`,
      visibleIf:
        "{panel.conditionType} = '208' || {panel.conditionType} = '210' || {panel.conditionType} = '211' || {panel.conditionType} = '214' || {panel.conditionType} = '215' || {panel.conditionType} = '216'",
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "dropdown",
      name: "subTypeID",
      title: "Sub Type",
      isRequired: true,
      visibleIf: "{panel.conditionType} = '215'",
      choices: [
        { value: "5865", text: "Primary Progressive" },
        { value: "5866", text: "Progressive Relapsing" },
        { value: "5863", text: "Relapsing Remitting" },
        { value: "5864", text: "Secondary Progressive" },
      ],
    },

    // High Blood Pressure Fields
    {
      type: "text",
      name: "lastSystolicReading",
      title: `What was ${yourReplace} last systolic reading?`,
      isRequired: true,
      visibleIf: "{panel.conditionType} = '218'",
      inputType: "number",
      min: 100,
      max: 300,
      validators: [
        {
          type: "regex",
          text: "Please enter a valid reading value between 100 - 300.",
          regex: "^([1-2][0-9]{2}|300)$",
        },
      ],
    },
    {
      type: "text",
      name: "lastDiastolicReading",
      title: `What was ${yourReplace} last diastolic reading?`,
      isRequired: true,
      visibleIf: "{panel.conditionType} = '218'",
      inputType: "number",
      min: 50,
      max: 300,
      validators: [
        {
          type: "regex",
          text: "Please enter a valid reading value between 50 - 300.",
          regex: "^([5-9][0-9]|[1-2][0-9]{2}|300)$",
        },
      ],
    },

    // High Cholesterol Fields
    {
      type: "text",
      name: "readingMmol",
      title: `What was ${yourReplace} last cholesterol reading (mmol)?`,
      visibleIf: "{panel.conditionType} = '219'",
      inputType: "number",
      min: 1,
      max: 30,
      step: 0.1,
      validators: [
        {
          type: "expression",
          text: "Please enter a valid mmol reading (e.g. between 1 and 30).",
          expression:
            "{readingMmol} notempty and {readingMmol} < 30 and {readingMmol} > 1 or {readingMmol} empty",
        },
      ],
    },

    // Heart Condition Fields
    {
      type: "dropdown",
      name: "heartConditionType",
      title: `What type of heart condition do ${youReplace} have?`,
      isRequired: true,
      visibleIf: "{panel.conditionType} = '210'",
      choices: [
        { value: "5997", text: "Heart Attack" },
        { value: "5998", text: "Angina" },
        { value: "5999", text: "Heart Failure" },
        { value: "6000", text: "Aortic Aneurysm" },
        { value: "6001", text: "Cardiomyopathy" },
        { value: "6002", text: "Heart Valve Disorders" },
        { value: "6003", text: "Atrial Fibrillation (AF)" },
        { value: "6004", text: "Other" },
      ],
    },
    {
      type: "text",
      name: "noOfOccurrences",
      title: "How many times has this occurred?",
      isRequired: true,
      visibleIf: "{panel.conditionType} = '210'",
      inputType: "number",
      min: 1,
      max: 99,
      validators: [
        {
          type: "regex",
          text: "Please enter a valid integer (e.g. 1–99).",
          regex: "^([0-9]|[1-9][0-9])$",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "conditionOngoing",
      title: "Is this condition ongoing?",
      isRequired: true,
      visibleIf: "{panel.conditionType} = '210'",
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },

    // Diabetes Fields
    {
      type: "dropdown",
      name: "diabetesType",
      title: `What type of diabetes do ${youReplace} have?`,
      isRequired: true,
      visibleIf: "{panel.conditionType} = '211'",
      choices: [
        { value: "5820", text: "Type 1" },
        { value: "5821", text: "Type 2" },
      ],
    },
    {
      type: "dropdown",
      name: "diabetesControlMethod",
      title: `How is ${yourReplace} diabetes controlled?`,
      isRequired: true,
      visibleIf: "{panel.conditionType} = '211'",
      choices: [
        { text: "Diet", value: "5822" },
        { text: "Insulin", value: "5823" },
        { text: "Tablet", value: "5824" },
      ],
    },
    {
      type: "dropdown",
      name: "diabetesTestingFrequencyID",
      title: `How often do ${youReplace} test ${yourReplace} blood sugar?`,
      visibleIf: "{panel.conditionType} = '211'",
      choices: [
        { text: "As Required", value: "5833" },
        { text: "Daily", value: "5984" },
        { text: "Weekly", value: "5985" },
        { text: "Fortnightly", value: "5986" },
        { text: "Every Four Weeks", value: "5987" },
        { text: "Monthly", value: "5988" },
        { text: "Quarterly", value: "5989" },
        { text: "Half Yearly", value: "5990" },
        { text: "Yearly", value: "5991" },
      ],
    },
    {
      type: "text",
      name: "readingHbA1c",
      title: `What was ${yourReplace} last HbA1c reading?`,
      visibleIf: "{panel.conditionType} = '211'",
      inputType: "number",
      min: 0.1,
      max: 200,
      step: 0.1,
      validators: [
        {
          type: "regex",
          text: "Please enter a valid HbA1c reading if known.",
          regex: "^([0-9]|[1-9][0-9]|1[0-9]{2}|200)(\\.\\d{1})?$",
        },
      ],
    },
    {
      type: "dropdown",
      name: "hbA1cUnitID",
      title: `What unit is ${yourReplace} HbA1c measured in?`,
      visibleIf: "{panel.conditionType} = '211'",
      choices: [
        { text: "DCCT (%)", value: "100642" },
        { text: "IFCC (mmol/mol)", value: "100643" },
      ],
    },
    {
      type: "text",
      name: "diabetesNoOfTests",
      title: `How many blood glucose tests do ${youReplace} perform per day?`,
      visibleIf: "{panel.conditionType} = '211'",
      inputType: "number",
      min: 1,
      max: 99,
      validators: [
        {
          type: "regex",
          text: "Please enter a valid number of tests if known.",
          regex: "^([1-9]|[1-9][0-9])$",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "penultimateReadingKnown",
      title: `Do ${youReplace} know ${yourReplace} previous HbA1c reading?`,
      isRequired: true,
      visibleIf: "{panel.conditionType} = '211'",
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "text",
      name: "penultimateReadingHbA1c",
      title: `What was ${yourReplace} previous HbA1c reading?`,
      visibleIf:
        "{panel.conditionType} = '211' && {panel.penultimateReadingKnown} = 'true'",
      inputType: "number",
      min: 0.1,
      max: 200,
      step: 0.1,
      validators: [
        {
          type: "regex",
          text: "Please enter a valid HbA1c reading.",
          regex: "^([0-9]|[1-9][0-9]|1[0-9]{2}|200)(\\.\\d{1})?$",
        },
      ],
    },
    {
      type: "text",
      name: "penultimateReading",
      title: `When was ${yourReplace} previous reading taken?`,
      visibleIf:
        "{panel.conditionType} = '211' && {panel.penultimateReadingKnown} = 'true'",
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "radiogroup",
      name: "heartDisease",
      title: `Do ${youReplace} have heart disease?`,
      visibleIf: "{panel.conditionType} = '211'",
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: "eyeDisease",
      title: `Do ${youReplace} have retinopathy?`,
      visibleIf: "{panel.conditionType} = '211'",
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: "kidneyDisease",
      title: `Do ${youReplace} have kidney disease?`,
      visibleIf: "{panel.conditionType} = '211'",
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: "amputation",
      title: `Have ${youReplace} had any amputations?`,
      visibleIf: "{panel.conditionType} = '211'",
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: "circulation",
      title: `Do ${youReplace} have circulation issues?`,
      visibleIf: "{panel.conditionType} = '211'",
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: "neuropathy",
      title: `Do ${youReplace} have neuropathy?`,
      visibleIf: "{panel.conditionType} = '211'",
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: "ulceration",
      title: `Do ${youReplace} have ulceration?`,
      visibleIf: "{panel.conditionType} = '211'",
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },

    // Cancer Fields
    {
      type: "dropdown",
      name: "tumourType",
      title: `What type of tumour did/do ${youReplace} have?`,
      isRequired: true,
      visibleIf: "{panel.conditionType} = '212'",
      choices: [
        { value: "5860", text: "Benign" },
        { value: "5861", text: "Pre-Cancerous" },
        { value: "5862", text: "Malignant" },
      ],
    },
    {
      type: "dropdown",
      name: "tumourLocation",
      title: "Where is/was the tumour located?",
      isRequired: true,
      visibleIf: "{panel.conditionType} = '212'",
      choices: [
        { value: "5939", text: "Bone" },
        { value: "5940", text: "Brain and Central Nervous System" },
        { value: "5941", text: "Breast" },
        { value: "5942", text: "Circulatory system" },
        { value: "5943", text: "Connective and other soft tissue" },
        { value: "5944", text: "Digestive System" },
        { value: "5945", text: "Liver" },
        { value: "5946", text: "Lymph Nodes" },
        { value: "5947", text: "Oral" },
        { value: "5948", text: "Reproductive system" },
        { value: "5949", text: "Respiratory system" },
        { value: "5950", text: "Skin" },
        { value: "5951", text: "Urinary system" },
        { value: "5952", text: "Other" },
        { value: "5953", text: "Not specified" },
      ],
    },
    {
      type: "dropdown",
      name: "generalGradeID",
      title: "What is the grade of the tumour?",
      isRequired: true,
      visibleIf: "{panel.conditionType} = '212'",
      choices: [
        { value: "5954", text: "Grade 1 (Low Grade)" },
        { value: "5955", text: "Grade 2 (Intermediate Grade)" },
        { value: "5956", text: "Grade 3 (High Grade)" },
        { value: "5966", text: "Unknown" },
      ],
    },
    {
      type: "dropdown",
      name: "spreadTypeID",
      title: "What is the nature of the tumour?",
      isRequired: true,
      visibleIf: "{panel.conditionType} = '212'",
      choices: [
        { value: "5967", text: "Carcinoma In Situ (Stage 0, Tis, Ta)" },
        { value: "5968", text: "Only Local Tumour Growth" },
        { value: "5969", text: "Tumour Invaded Adjacent Lymph Nodes" },
        { value: "5970", text: "Tumour Invaded Distant Lymph Nodes" },
        {
          value: "5971",
          text: "Tumour Spread To Distant Organs (Distant Metastases)",
        },
      ],
    },
    {
      type: "checkbox",
      name: "spreadToDistantOrgansCheckBoxID",
      title: "Which organs has the tumour spread to?",
      visibleIf:
        "{panel.conditionType} = '212' && {panel.spreadTypeID} = '5971'",
      choices: [
        { value: "5972", text: "Brain and Central Nervous system" },
        { value: "5973", text: "Reproductive" },
        { value: "5974", text: "Urinary" },
        { value: "5975", text: "Respiratory" },
        { value: "5976", text: "Skin" },
        { value: "5977", text: "Digestive" },
        { value: "5978", text: "Liver" },
        { value: "5979", text: "Heart" },
        { value: "5980", text: "Other" },
        { value: "5981", text: "Current Level" },
        { value: "5982", text: "Pre-Treatment Level" },
      ],
    },
    {
      type: "dropdown",
      name: "stageTypeID",
      title: "What classification system is being used?",
      isRequired: true,
      visibleIf: "{panel.conditionType} = '212'",
      choices: [
        { value: "5957", text: "Dukes" },
        { value: "5958", text: "TNM" },
        { value: "5959", text: "MAC" },
        { value: "5960", text: "FIGO" },
        { value: "5961", text: "Clark Level" },
        { value: "5962", text: "Breslow Thickness" },
        { value: "5963", text: "Ann Arbor" },
        { value: "5964", text: "General" },
        { value: "5965", text: "Not Specified" },
      ],
    },
    {
      type: "dropdown",
      name: "generalStageTypeID",
      title: "What is the general stage?",
      visibleIf:
        "{panel.conditionType} = '212' && {panel.stageTypeID} = '5964'",
      isRequired: true,
      choices: [
        { value: "7479", text: "Stage 1" },
        { value: "7480", text: "Stage 2" },
        { value: "7481", text: "Stage 3" },
        { value: "7482", text: "Stage 4" },
      ],
    },
    {
      type: "dropdown",
      name: "generalSubStageTypeID",
      title: "What is the general sub-stage?",
      visibleIf:
        "{panel.conditionType} = '212' && {panel.stageTypeID} = '5964'",
      isRequired: true,
      choices: [
        { value: "7483", text: "A" },
        { value: "7484", text: "B" },
        { value: "7485", text: "C" },
      ],
    },
    {
      type: "dropdown",
      name: "annArborClassificationID",
      title: "What is the Ann Arbor classification?",
      visibleIf:
        "{panel.conditionType} = '212' && {panel.stageTypeID} = '5963'",
      isRequired: true,
      choices: [
        { value: "7486", text: "Stage I" },
        { value: "7487", text: "Stage II" },
        { value: "7488", text: "Stage III" },
        { value: "7489", text: "Stage IV" },
      ],
    },
    {
      type: "dropdown",
      name: "breslowThicknessID",
      title: "What is the Breslow thickness?",
      visibleIf:
        "{panel.conditionType} = '212' && {panel.stageTypeID} = '5962'",
      isRequired: true,
      choices: [
        { value: "7490", text: "1" },
        { value: "7491", text: "2" },
        { value: "7492", text: "3" },
        { value: "7493", text: "4" },
        { value: "7494", text: "5" },
        { value: "7495", text: "6" },
        { value: "7496", text: "7" },
        { value: "7497", text: "8" },
        { value: "7498", text: "9" },
        { value: "7499", text: "10" },
      ],
    },
    {
      type: "dropdown",
      name: "tNMTStageTypeID",
      title: "What is the TNM T stage?",
      visibleIf:
        "{panel.conditionType} = '212' && {panel.stageTypeID} = '5958'",
      isRequired: true,
      choices: [
        { value: "7445", text: "Ta" },
        { value: "7446", text: "Tis" },
        { value: "7447", text: "T0" },
        { value: "7448", text: "T1" },
        { value: "7449", text: "T2" },
        { value: "7450", text: "T3" },
        { value: "7451", text: "T4" },
        { value: "7452", text: "TX" },
      ],
    },
    {
      type: "dropdown",
      name: "tNMTStageSubTypeID",
      title: "What is the TNM T stage sub-type?",
      visibleIf:
        "{panel.conditionType} = '212' && {panel.stageTypeID} = '5958'",
      isRequired: true,
      choices: [
        { value: "7453", text: "a" },
        { value: "7454", text: "b" },
        { value: "7455", text: "c" },
      ],
    },
    {
      type: "dropdown",
      name: "tNMNStageTypeID",
      title: "What is the TNM N stage?",
      visibleIf:
        "{panel.conditionType} = '212' && {panel.stageTypeID} = '5958'",
      isRequired: true,
      choices: [
        { value: "7456", text: "N0" },
        { value: "7457", text: "N1" },
        { value: "7458", text: "N2" },
        { value: "7459", text: "N3" },
        { value: "7460", text: "NX" },
      ],
    },
    {
      type: "dropdown",
      name: "tNMNStageSubTypeID",
      title: "What is the TNM N stage sub-type?",
      visibleIf:
        "{panel.conditionType} = '212' && {panel.stageTypeID} = '5958'",
      isRequired: true,
      choices: [
        { value: "7461", text: "a" },
        { value: "7462", text: "b" },
        { value: "7463", text: "c" },
      ],
    },
    {
      type: "dropdown",
      name: "tNMMStageTypeID",
      title: "What is the TNM M stage?",
      visibleIf:
        "{panel.conditionType} = '212' && {panel.stageTypeID} = '5958'",
      isRequired: true,
      choices: [
        { value: "7464", text: "M0" },
        { value: "7465", text: "M1" },
        { value: "7466", text: "MX" },
      ],
    },
    {
      type: "dropdown",
      name: "fIGOClassificationID",
      title: "What is the FIGO classification?",
      visibleIf:
        "{panel.conditionType} = '212' && {panel.stageTypeID} = '5960'",
      isRequired: true,
      choices: [
        { value: "7479", text: "1" },
        { value: "7480", text: "2" },
        { value: "7481", text: "3" },
        { value: "7482", text: "4" },
      ],
    },
    {
      type: "dropdown",
      name: "mACClassificationID",
      title: "What is the MAC classification?",
      visibleIf:
        "{panel.conditionType} = '212' && {panel.stageTypeID} = '5959'",
      isRequired: true,
      choices: [
        { value: "7467", text: "A1" },
        { value: "7468", text: "A2" },
        { value: "7469", text: "A3" },
        { value: "7470", text: "B1" },
        { value: "7471", text: "B2" },
        { value: "7472", text: "B3" },
        { value: "7473", text: "C1" },
        { value: "7474", text: "C2" },
        { value: "7475", text: "C3" },
        { value: "7476", text: "D1" },
        { value: "7477", text: "D2" },
        { value: "7478", text: "D3" },
      ],
    },
    {
      type: "dropdown",
      name: "dukesClassificationID",
      title: "What is the Dukes classification?",
      visibleIf:
        "{panel.conditionType} = '212' && {panel.stageTypeID} = '5957'",
      isRequired: true,
      choices: [
        { value: "7441", text: "A" },
        { value: "7442", text: "B" },
        { value: "7443", text: "C" },
        { value: "7444", text: "D" },
      ],
    },
    {
      type: "dropdown",
      name: "clarkLevelID",
      title: "What is the Clark Level?",
      visibleIf:
        "{panel.conditionType} = '212' && {panel.stageTypeID} = '5961'",
      isRequired: true,
      choices: [
        { value: "7483", text: "1" },
        { value: "7484", text: "2" },
        { value: "7485", text: "3" },
        { value: "7486", text: "4" },
        { value: "7487", text: "5" },
      ],
    },
    {
      type: "text",
      name: "numberOfNodesAffected",
      title: "How many lymph nodes are affected?",
      visibleIf: "{panel.conditionType} = '212'",
      inputType: "number",
      min: 1,
      max: 99,
      validators: [
        {
          type: "regex",
          text: "Please enter a valid number if nodes are affected.",
          regex: "^([1-9]|[1-9][0-9])$",
        },
      ],
    },
    {
      type: "checkbox",
      name: "nodeLocationsID",
      title: "Which lymph nodes are affected?",
      visibleIf:
        "{panel.conditionType} = '212' && {panel.numberOfNodesAffected} > 0",
      choices: [
        { value: "6030", text: "Head, face and neck" },
        { value: "6031", text: "Chest" },
        { value: "6032", text: "Abdomen" },
        { value: "6033", text: "Armpit or arm" },
        { value: "6034", text: "Groin or leg" },
        { value: "6035", text: "Pelvic" },
        { value: "6036", text: "Other" },
      ],
    },
    {
      type: "radiogroup",
      name: "anyRecurrences",
      title: "Has the cancer come back?",
      isRequired: true,
      visibleIf: "{panel.conditionType} = '212'",
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "text",
      name: "recurrenceDate",
      title: "When did the cancer come back?",
      visibleIf:
        "{panel.conditionType} = '212' && {panel.anyRecurrences} = 'true'",
      isRequired: true,
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "radiogroup",
      name: "radiotherapy",
      title: `Have ${youReplace} had radiotherapy?`,
      isRequired: true,
      visibleIf: "{panel.conditionType} = '212'",
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "text",
      name: "radiotherapyStartDate",
      title: `When did ${yourReplace} radiotherapy start?`,
      visibleIf:
        "{panel.conditionType} = '212' && {panel.radiotherapy} = 'true'",
      isRequired: true,
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "text",
      name: "radiotherapyEndDate",
      title: `When did ${yourReplace} radiotherapy end?`,
      visibleIf:
        "{panel.conditionType} = '212' && {panel.radiotherapy} = 'true'",
      isRequired: true,
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "radiogroup",
      name: "chemotherapy",
      title: `Have ${youReplace} had chemotherapy?`,
      isRequired: true,
      visibleIf: "{panel.conditionType} = '212'",
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "text",
      name: "chemotherapyStartDate",
      title: `When did ${yourReplace} chemotherapy start?`,
      visibleIf:
        "{panel.conditionType} = '212' && {panel.chemotherapy} = 'true'",
      isRequired: true,
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "text",
      name: "chemotherapyEndDate",
      title: `When did ${yourReplace} chemotherapy end?`,
      visibleIf:
        "{panel.conditionType} = '212' && {panel.chemotherapy} = 'true'",
      isRequired: true,
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "radiogroup",
      name: "boneMarrow",
      title: `Have ${youReplace} had a bone marrow transplant?`,
      isRequired: true,
      visibleIf: "{panel.conditionType} = '212'",
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "text",
      name: "boneMarrowStartDate",
      title: `When did ${yourReplace} bone marrow transplant start?`,
      isRequired: true,
      visibleIf: "{panel.conditionType} = '212' && {panel.boneMarrow} = 'true'",
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "text",
      name: "boneMarrowEndDate",
      title: `When did ${yourReplace} bone marrow transplant end?`,
      isRequired: true,
      visibleIf: "{panel.conditionType} = '212' && {panel.boneMarrow} = 'true'",
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "radiogroup",
      name: "hormoneTherapy",
      title: `Have ${youReplace} had hormone therapy for this condition?`,
      visibleIf: "{panel.conditionType} = '212'",
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "text",
      name: "hormoneTherapyStartDate",
      title: "When did the hormone therapy start?",
      visibleIf:
        "{panel.conditionType} = '212' && {panel.hormoneTherapy} = 'true'",
      isRequired: false,
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "text",
      name: "hormoneTherapyEndDate",
      title: "When did the hormone therapy end?",
      visibleIf:
        "{panel.conditionType} = '212' && {panel.hormoneTherapy} = 'true'",
      isRequired: false,
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "text",
      name: "gleasonScoreResult",
      title: `What is ${yourReplace} Gleason score?`,
      visibleIf:
        "{panel.conditionName} = 'Malignant Neoplasm Of Prostate' || {panel.conditionName} = 'Malignant Neoplasm Prostate' || {panel.conditionName} = 'Prostate Calculus' || {panel.conditionName} = 'Prostate Cancer' || {panel.conditionName} = 'Prostate Enlarged' || {panel.conditionName} = 'Prostate Hyperplasia' || {panel.conditionName} = 'Prostate Hypertrophy' || {panel.conditionName} = 'Prostate Neoplasm' || {panel.conditionName} = 'Prostate Neoplasm Malignant' || {panel.conditionName} = 'Prostate Neoplasm Unknown' || {panel.conditionName} = 'Inflammatory Prostate Disease' || {panel.conditionName} = 'Hyperplasia Of Prostate' || {panel.conditionName} = 'Enlarged Prostate' || {panel.conditionName} = 'Enlarge Prostate' || {panel.conditionName} = 'Carcinoma Prostate' || {panel.conditionName} = 'Carcinoma Of Prostate' || {panel.conditionName} = 'Carcinoma In Situ Of Prostate' || {panel.conditionName} = 'Cancer Of Prostate' || {panel.conditionName} = 'Ca Prostate' || {panel.conditionName} = 'Benign Tumor Of Prostate' || {panel.conditionName} = 'Benign Prostate Tumour' || {panel.conditionName} = 'Benign Neoplasm Of Prostate' || {panel.conditionName} = 'Adenocarcinoma Prostate' || {panel.conditionName} = 'Adeno Carcinoma Prostate' || {panel.conditionName} = 'Adeno CA Prostate' || {panel.conditionName} = 'Prostate Tuberculosis'",
      inputType: "number",
      min: 2,
      max: 10,
      step: 0.1,
      validators: [
        {
          type: "regex",
          text: "Please enter a valid Gleason score (e.g. 2.0 – 10.0).",
          regex: "^([2-9]|10)(\\.\\d{1})?$",
        },
      ],
    },

    // Stroke Fields
    {
      type: "dropdown",
      name: "strokeType",
      title: `What type of stroke did ${youReplace} have?`,
      isRequired: true,
      visibleIf: "{panel.conditionType} = '213'",
      choices: [
        {
          value: "6043",
          text: "CVA (Cerebrovascular Accident - Major Stroke)",
        },
        { value: "6044", text: "Subarachnoid Haemorrhage (SAH)" },
        { value: "6045", text: "Cerebral Haemorrhage/Bleed" },
        {
          value: "6046",
          text: "TIA (Transient Ischaemic Attack - Mini-Stroke)",
        },
      ],
    },
    {
      type: "dropdown",
      name: "bodyPartAffected",
      title: "Which area was most affected by the stroke?",
      isRequired: true,
      visibleIf: "{panel.conditionType} = '213'",
      choices: [
        { value: "6038", text: "Speech" },
        { value: "6039", text: "Vision" },
        { value: "6040", text: "Arm" },
        { value: "6041", text: "Leg" },
        { value: "6042", text: "Memory Loss" },
      ],
    },
    {
      type: "text",
      name: "durationTime",
      title: "How long did the symptoms last?",
      visibleIf: "{panel.conditionType} = '213'",
      inputType: "number",
      min: 0,
      max: 1000,
      validators: [
        {
          type: "regex",
          text: "Please enter a numeric value between 0 and 1000.",
          regex: "^([0-9]|[1-9][0-9]|[1-9][0-9]{2}|1000)$",
        },
      ],
    },
    {
      type: "dropdown",
      name: "durationFrequencyID",
      title: "Symptoms duration time frame",
      isRequired: true,
      visibleIf: "{panel.conditionType} = '213'",
      choices: [
        { value: "6047", text: "Minutes" },
        { value: "6048", text: "Hours" },
        { value: "6049", text: "Days" },
        { value: "6050", text: "Months" },
        { value: "6051", text: "Years" },
      ],
    },

    {
      type: "radiogroup",
      name: "madeFullRecovery",
      title: `Have ${youReplace} made a full recovery?`,
      isRequired: false,
      visibleIf: "{panel.conditionType} = '213'",
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "dropdown",
      name: "recoveryFrequencyID",
      title: "Recovery time frame",
      visibleIf: "{panel.madeFullRecovery} = 'true'",
      isRequired: false,
      choices: [
        { value: "6047", text: "Minutes" },
        { value: "6048", text: "Hours" },
        { value: "6049", text: "Days" },
        { value: "6050", text: "Months" },
        { value: "6051", text: "Years" },
      ],
    },
    {
      type: "text",
      name: "recoveryTime",
      title:
        "How long did it take to recover? (e.g. if fully recovered in 2 months, set the timeframe above to months and this to 2)",
      visibleIf:
        "{panel.conditionType} = '213' && {panel.madeFullRecovery} = 'true'",
      inputType: "number",
      min: 0,
      max: 1000,
      validators: [
        {
          type: "regex",
          text: "Please enter a numeric value between 0 and 1000.",
          regex: "^([0-9]|[1-9][0-9]|[1-9][0-9]{2}|1000)$",
        },
      ],
    },

    // Respiratory Panel
    {
      type: "dropdown",
      name: "respiratoryType",
      title: `What type of respiratory condition do ${youReplace} have?`,
      visibleIf: "{panel.conditionType} = '214'",
      isRequired: true,
      choices: [
        { value: "6020", text: "Chronic Obstructive Airways" },
        { value: "6021", text: "Pulmonary Disease" },
        { value: "6022", text: "Emphysema" },
        { value: "6023", text: "Bronchiectasis" },
        { value: "6024", text: "Pneumoconiosis" },
        { value: "6025", text: "Asbestosis" },
        { value: "6026", text: "Asthma" },
        { value: "6027", text: "Pleural Plaques" },
        { value: "6029", text: "Other" },
      ],
    },

    // Multiple Sclerosis Panel
    {
      type: "text",
      name: "noOfAttacks",
      title: `How many MS attacks have ${youReplace} had in the last 12 months?`,
      isRequired: true,
      inputType: "number",
      visibleIf: "{panel.conditionType} = '215'",
      min: 0,
      max: 100,
      validators: [
        {
          type: "regex",
          text: "Please enter a value between 0 and 100.",
          regex: "^([0-9]|[1-9][0-9]|100)$",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "bladderIncontinence",
      title: `Do ${youReplace} have bladder incontinence due to MS?`,
      isRequired: false,
      visibleIf: "{panel.conditionType} = '215'",
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: "impairedSpeech",
      visibleIf: "{panel.conditionType} = '215'",
      title: `Do ${youReplace} have impaired speech due to MS?`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: "impairedVision",
      visibleIf: "{panel.conditionType} = '215'",
      title: `Do ${youReplace} have impaired vision due to MS?`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: "limbParalysis",
      visibleIf: "{panel.conditionType} = '215'",
      title: `Do ${youReplace} have limb paralysis due to MS?`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: "mentalDeterioration",
      visibleIf: "{panel.conditionType} = '215'",
      title: `Do ${youReplace} have mental deterioration due to MS?`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: "secondaryInfection",
      visibleIf: "{panel.conditionType} = '215'",
      title: `Do ${youReplace} have secondary infections due to MS?`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: "useOfSteroids",
      visibleIf: "{panel.conditionType} = '215'",
      title: `Do ${youReplace} use steroids due to MS?`,
      isRequired: false,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },

    // Neurological Panel

    {
      type: "radiogroup",
      name: "mmseScoreKnown",
      title: `Do ${youReplace} know ${yourReplace} MMSE score?`,
      isRequired: true,
      visibleIf: "{panel.conditionType} = '216'",
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "text",
      name: "mmseScore",
      title: `What is ${yourReplace} MMSE score?`,
      visibleIf:
        "{panel.mmseScoreKnown} = 'true' && {panel.conditionType} = '216'",
      isRequired: true,
      inputType: "number",
      min: 0,
      max: 30,
      validators: [
        {
          type: "regex",
          text: "Please enter a numeric value between 0 and 30.",
          regex: "^([0-9]|[1-2][0-9]|30)$",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "falls",
      title: `Do ${youReplace} experience falls?`,
      isRequired: true,
      visibleIf: "{panel.conditionType} = '216'",
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: "pressureSores",
      title: `Do ${youReplace} have pressure sores?`,
      isRequired: true,
      visibleIf: "{panel.conditionType} = '216'",
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: "seizures",
      title: `Do ${youReplace} experience seizures?`,
      isRequired: true,
      visibleIf: "{panel.conditionType} = '216'",
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: "tremors",
      title: `Do ${youReplace} experience tremors?`,
      isRequired: true,
      visibleIf: "{panel.conditionType} = '216'",
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },

    //common fields
    {
      type: "text",
      name: "lastTreatmentDate",
      title: `When was ${yourReplace} last treatment?`,
      visibleIf: "{panel.conditionType} = '208'",
      isRequired: true,
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "radiogroup",
      name: "renalDialysis",
      title: `Are ${youReplace} on renal dialysis?`,
      visibleIf: "{panel.conditionType} = '208'",
      isRequired: true,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: "otherTreatment",
      title: `Are ${youReplace} receiving other treatment?`,
      visibleIf: "{panel.conditionType} = '208'",
      isRequired: true,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "radiogroup",
      name: "surgery",
      title: `Have ${youReplace} had surgery?`,
      isRequired: true,
      colCount: 2,
      visibleIf:
        "{panel.conditionType} = '208' || {panel.conditionType} = '212'",
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
    {
      type: "text",
      name: "surgeryDate",
      title: "When was the surgery?",
      visibleIf: "{panel.surgery} = 'true' && ({panel.conditionType} = '212')",
      isRequired: true,
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "text",
      name: "surgeryType",
      title: "What type of surgery was it?",
      visibleIf: "{panel.surgery} = 'true' && ({panel.conditionType} = '212')",
      isRequired: false,
      placeholder: "Enter surgery type",
    },
    {
      type: "text",
      name: "lastConsultationDate",
      title: `When was ${yourReplace} last consultation?`,
      visibleIf:
        "{panel.conditionType} = '212' || {panel.conditionType} = '210'",
      isRequired: true,
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },

    {
      type: "text",
      name: "lastReading",
      title: `When was ${yourReplace} last reading taken?`,
      visibleIf:
        "{panel.conditionType} = '218' || {panel.conditionType} = '219' || {panel.conditionType} = '211'",
      inputType: "date",
      min: "1920-01-01",
      max: new Date().toISOString().split("T")[0],
    },
    {
      type: "radiogroup",
      name: "discharged",
      title: `Have ${youReplace} been discharged from treatment?`,
      visibleIf:
        "{panel.conditionType} = '213' || {panel.conditionType} = '212'",
      isRequired: true,
      colCount: 2,
      choices: [
        { value: "true", text: "Yes" },
        { value: "false", text: "No" },
      ],
    },
  ];
}

export const createMedicalConditionModel = () => {
  return new Model({
    elements: getMedicalConditionElements("medicalInformation", false),
  });
};
